import { likeButtonClicked, dislikeButtonClicked } from 'web-ui-kit/LikeDislikeButtonEvents';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/**
 * Event fired when the user clicks on the product card button.
 */


var productCardButtonClicked = function productCardButtonClicked() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$event = _ref.event,
      event = _ref$event === void 0 ? {
    type: '',
    payload: {}
  } : _ref$event,
      cardPosition = _ref.cardPosition,
      productId = _ref.productId,
      _ref$product = _ref.product,
      product = _ref$product === void 0 ? null : _ref$product;

  var payload = event.payload;
  return {
    type: 'product-card-button-clicked',
    payload: _objectSpread2(_objectSpread2({}, payload), {}, {
      cardPosition: cardPosition,
      productId: productId,
      product: product
    })
  };
};
/**
 * Event fired when the user clicks on the product card add to cart button.
 */


var productCardAtcButtonClicked = function productCardAtcButtonClicked() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      cardPosition = _ref2.cardPosition,
      productId = _ref2.productId,
      _ref2$product = _ref2.product,
      product = _ref2$product === void 0 ? null : _ref2$product;

  return {
    type: 'product-card-atc-button-clicked',
    payload: {
      cardPosition: cardPosition,
      productId: productId,
      product: product
    }
  };
};
/**
 * Event fired when the user clicks on the product card
 * outside of the like/dislike/secondary buttons.
 */


var productCardClicked = function productCardClicked() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      productId = _ref3.productId,
      _ref3$referrer = _ref3.referrer,
      referrer = _ref3$referrer === void 0 ? '' : _ref3$referrer,
      _ref3$cardPosition = _ref3.cardPosition,
      cardPosition = _ref3$cardPosition === void 0 ? 0 : _ref3$cardPosition,
      _ref3$product = _ref3.product,
      product = _ref3$product === void 0 ? null : _ref3$product;

  return {
    type: 'product-card-clicked',
    payload: {
      cardPosition: cardPosition,
      productId: productId,
      product: product,
      referrer: referrer
    }
  };
};
/**
 * Event fired when the user clicks on a product card
 * color tile representing a product variant.
 */


var productCardColorTileClicked = function productCardColorTileClicked() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      colorVariant = _ref4.colorVariant,
      productId = _ref4.productId,
      _ref4$product = _ref4.product,
      product = _ref4$product === void 0 ? null : _ref4$product,
      _ref4$referrer = _ref4.referrer,
      referrer = _ref4$referrer === void 0 ? '' : _ref4$referrer;

  return {
    type: 'product-card-color-tile-clicked',
    payload: {
      colorVariant: colorVariant,
      productId: productId,
      product: product,
      referrer: referrer
    }
  };
};
/**
 * Event fired when user likes, dislikes, or unlikes a product.
 */


var productLikeStatusChanged = function productLikeStatusChanged() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref5$event = _ref5.event,
      event = _ref5$event === void 0 ? {
    type: '',
    payload: {}
  } : _ref5$event,
      productId = _ref5.productId,
      cardPosition = _ref5.cardPosition,
      parentProductId = _ref5.parentProductId,
      product = _ref5.product,
      _ref5$referrer = _ref5.referrer,
      referrer = _ref5$referrer === void 0 ? '' : _ref5$referrer;

  var newLikeStatus = 0;
  var type = event.type,
      isSelected = event.payload.isSelected;

  switch (type) {
    case dislikeButtonClicked().type:
      {
        newLikeStatus = isSelected ? 0 : -1;
        break;
      }

    case likeButtonClicked().type:
      {
        newLikeStatus = isSelected ? 0 : 1;
        break;
      }
  }

  return {
    type: 'product-like-status-changed',
    payload: {
      cardPosition: cardPosition,
      newLikeStatus: newLikeStatus,
      parentProductId: parentProductId,
      productId: productId,
      product: product,
      referrer: referrer
    }
  };
};

export { productCardAtcButtonClicked, productCardButtonClicked, productCardClicked, productCardColorTileClicked, productLikeStatusChanged };